import EditableInput from "./editable-input.vue";

export default EditableInput;
